var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDydxChip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 15,
    viewBox: "0 0 43 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 15,
    rx: 2,
    fill: "#F4F5FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3663 3.75L26.3979 10.4027H27.9234L32.9175 3.75H31.3663Z",
    fill: "#3A3A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0823 3.75L29.5442 5.71034L28.7815 6.77961L26.5251 3.75H28.0823Z",
    fill: "#3A3A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5145 10.4031L29.8938 8.23489L30.6565 7.19531L33.0399 10.4031H31.5145Z",
    fill: "url(#paint0_linear_14232_49913)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6184 3.75H25.9532V10.4027H24.6184V10.1542C24.233 10.3509 23.7904 10.4627 23.3197 10.4627C21.8256 10.4627 20.6143 9.33566 20.6143 7.94542C20.6143 6.55518 21.8256 5.42817 23.3197 5.42817C23.7904 5.42817 24.233 5.53997 24.6184 5.73659V3.75ZM23.3055 9.35786C24.1518 9.35786 24.8378 8.71955 24.8378 7.93216C24.8378 7.14477 24.1518 6.50646 23.3055 6.50646C22.4592 6.50646 21.7732 7.14477 21.7732 7.93216C21.7732 8.71955 22.4592 9.35786 23.3055 9.35786Z",
    fill: "#3A3A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7469 3.75L15.7837 10.4027H17.3397L22.2981 3.75H20.7469Z",
    fill: "#3A3A3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.341 3.75L18.8981 5.76974L18.0401 6.89842L15.7202 3.75H17.341Z",
    fill: "#3A3A3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0042 3.75H15.3389V10.4027H14.0042V10.1542C13.6187 10.3509 13.1761 10.4627 12.7055 10.4627C11.2113 10.4627 10 9.33566 10 7.94542C10 6.55518 11.2113 5.42817 12.7055 5.42817C13.1761 5.42817 13.6187 5.53997 14.0042 5.73659V3.75ZM12.6913 9.35786C13.5375 9.35786 14.2236 8.71955 14.2236 7.93216C14.2236 7.14477 13.5375 6.50646 12.6913 6.50646C11.845 6.50646 11.1589 7.14477 11.1589 7.93216C11.1589 8.71955 11.845 9.35786 12.6913 9.35786Z",
    fill: "#3A3A3A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14232_49913",
    x1: 31.8641,
    y1: 9.8982,
    x2: 29.5126,
    y2: 6.50636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6966FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6966FF",
    stopOpacity: 0.36
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDydxChip);
export default __webpack_public_path__ + "static/media/dydx_chip.e0ed7e0c817efea67ff6a2ff48be93b6.svg";
export { ForwardRef as ReactComponent };